import { render } from "./TrailersMovie.vue?vue&type=template&id=5d024b11"
import script from "./TrailersMovie.vue?vue&type=script&lang=js"
export * from "./TrailersMovie.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__